export const SURVEY_MANAGER_API_PREFIX = '/api/survey-manager';

// list available defect layers
export const AVAILABLE_DEFECT_LAYERS_PATH = `${SURVEY_MANAGER_API_PREFIX}/defects`;

// single defect by slug
export function bySlugPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}`;
}

// GeoJSON FeatureCollection for a defect slice
export function defectFeaturesPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/features`;
}

// defect data summary cards for one defect
export function defectDataSummaryPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/data/summary`;
}

// defect data rows grouped by survey run
export function defectDataPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/data`;
}

// defect data aggregated by severity bands
export function defectDataBandsPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/data/bands`;
}

// defect data aggregated by section
export function defectDataSectionsPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/data/sections`;
}

// defect data aggregated by road
export function defectDataRoadsPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/data/roads`;
}

// list supported survey type slugs
export const SURVEY_TYPES_PATH = `${SURVEY_MANAGER_API_PREFIX}/survey-types`;

// survey years for one client slug
export function clientSurveyYearsPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/clients/${encodeURIComponent(slug)}/survey-years`;
}

// defect statistics cards
export const DASHBOARD_STATS_PATH = '/api/survey-manager/defects/statistics';

// visualisation rulesets for one defect
export function defectRulesetsPath(slug: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/defects/${encodeURIComponent(slug)}/rulesets`;
}

export function defectRulesetPath(slug: string, rulesetSlug: string): string {
  return `${defectRulesetsPath(slug)}/${encodeURIComponent(rulesetSlug)}`;
}

export function defectRulesPath(slug: string, rulesetSlug: string): string {
  return `${defectRulesetPath(slug, rulesetSlug)}/rules`;
}

export function defectRulePath(
  slug: string,
  rulesetSlug: string,
  ruleSlug: string,
): string {
  return `${defectRulesPath(slug, rulesetSlug)}/${encodeURIComponent(ruleSlug)}`;
}

export function activeLayerVisualizationMeasureSettingsPath(instanceId: string): string {
  return `${SURVEY_MANAGER_API_PREFIX}/active-layers/${encodeURIComponent(instanceId)}/visualization-measure-settings`;
}

/** Layers & recipes catalogue (Built-in / Client / My Layers; recipes internally). */
export const AVAILABLE_VIEWS_PATH = `${SURVEY_MANAGER_API_PREFIX}/available-views`;
